const usandata =[
  {
      "name": "AKGD",
      "id": 0,
      "label": "AKGD",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.47982821487199995,
      "year": 2023,
      "centroid": [
          89.68358885850064,
          363.0716682573017
      ]
  },
  {
      "name": "AKMS",
      "id": 1,
      "label": "AKMS",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.225687874744,
      "year": 2023,
      "centroid": [
          83.39549764049552,
          329.982807044359
      ]
  },
  {
      "name": "AZNM",
      "id": 2,
      "label": "AZNM",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.353521440144,
      "year": 2023,
      "centroid": [
          173.88294565258624,
          273.3279984494679
      ]
  },
  {
      "name": "CAMX",
      "id": 3,
      "label": "CAMX",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.226468506576,
      "year": 2023,
      "centroid": [
          69.95340117068643,
          210.2798631831915
      ]
  },
  {
      "name": "ERCT",
      "id": 4,
      "label": "ERCT",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.35121537841600003,
      "year": 2023,
      "centroid": [
          291.62017736901544,
          328.8183837879146
      ]
  },
  {
      "name": "FRCC",
      "id": 5,
      "label": "FRCC",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.370536129656,
      "year": 2023,
      "centroid": [
          505.5937333579051,
          353.69736569461605
      ]
  },
  {
      "name": "HIMS",
      "id": 6,
      "label": "HIMS",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.52755697948,
      "year": 2023,
      "centroid": [
          249.97916926202842,
          389.65131903498246
      ]
  },
  {
      "name": "HIOA",
      "id": 7,
      "label": "HIOA",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.7198264636239999,
      "year": 2023,
      "centroid": [
          195.63292137444293,
          360.49799246039066
      ]
  },
  {
      "name": "MROE",
      "id": 8,
      "label": "MROE",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.675256967296,
      "year": 2023,
      "centroid": [
          403.86579816588267,
          131.37444015887203
      ]
  },
  {
      "name": "MROW",
      "id": 9,
      "label": "MROW",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.427926857456,
      "year": 2023,
      "centroid": [
          320.4012509516746,
          132.93190720700144
      ]
  },
  {
      "name": "NEWE",
      "id": 10,
      "label": "NEWE",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.24515740416,
      "year": 2023,
      "centroid": [
          584.6304719044684,
          107.27532280557803
      ]
  },
  {
      "name": "NWPP",
      "id": 11,
      "label": "NWPP",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.27481869222399996,
      "year": 2023,
      "centroid": [
          141.08178768325007,
          134.16357942357016
      ]
  },
  {
      "name": "NYCW",
      "id": 12,
      "label": "NYCW",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.40214559536,
      "year": 2023,
      "centroid": [
          594.9215702064422,
          145.26276436204355
      ]
  },
  {
      "name": "NYLI",
      "id": 13,
      "label": "NYLI",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.548533795112,
      "year": 2023,
      "centroid": [
          597.9918858936948,
          170.1877020603823
      ]
  },
  {
      "name": "NYUP",
      "id": 14,
      "label": "NYUP",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.124914247288,
      "year": 2023,
      "centroid": [
          540.1492331624623,
          130.69291320072008
      ]
  },
  {
      "name": "PRMS",
      "id": 26,
      "label": "PRMS",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.725711819824,
      "year": 2023,
      "centroid": [
          603.089293976572,
          383.79075975839095
      ]
  },
  {
      "name": "RFCE",
      "id": 15,
      "label": "RFCE",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.29951178711200005,
      "year": 2023,
      "centroid": [
          534.2994794813319,
          174.6025392559633
      ]
  },
  {
      "name": "RFCM",
      "id": 16,
      "label": "RFCM",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.555281429704,
      "year": 2023,
      "centroid": [
          448.25053319805374,
          144.5507082099222
      ]
  },
  {
      "name": "RFCW",
      "id": 17,
      "label": "RFCW",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.456270007168,
      "year": 2023,
      "centroid": [
          464.6393384649164,
          191.75578666412153
      ]
  },
  {
      "name": "RMPA",
      "id": 18,
      "label": "RMPA",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.5133450349359999,
      "year": 2023,
      "centroid": [
          229.32547324811722,
          184.01851926740062
      ]
  },
  {
      "name": "SPNO",
      "id": 19,
      "label": "SPNO",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.43516754655199996,
      "year": 2023,
      "centroid": [
          312.5512080556987,
          222.4719199466715
      ]
  },
  {
      "name": "SPSO",
      "id": 20,
      "label": "SPSO",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.44236695877599996,
      "year": 2023,
      "centroid": [
          301.46286265091464,
          276.7406020107352
      ]
  },
  {
      "name": "SRMV",
      "id": 21,
      "label": "SRMV",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.36453283953599996,
      "year": 2023,
      "centroid": [
          375.2738270328863,
          302.90620142025386
      ]
  },
  {
      "name": "SRMW",
      "id": 22,
      "label": "SRMW",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.626026813168,
      "year": 2023,
      "centroid": [
          387.99123757435075,
          213.69788848899194
      ]
  },
  {
      "name": "SRSO",
      "id": 23,
      "label": "SRSO",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.407170941128,
      "year": 2023,
      "centroid": [
          457.1576050146917,
          303.2390761308476
      ]
  },
  {
      "name": "SRTV",
      "id": 24,
      "label": "SRTV",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.425752791,
      "year": 2023,
      "centroid": [
          440.0194774815577,
          252.92878811585743
      ]
  },
  {
      "name": "SRVC",
      "id": 25,
      "label": "SRVC",
      "unit": (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
      "type": "eGRID subregion",
      "value": 0.283891439408,
      "year": 2023,
      "centroid": [
          519.6734619704152,
          248.50946847521743
      ]
  }
]

export default usandata
